import xhr from 'Common/utils/xhr'
import { folderItemsEndpoint } from './endpoints'

const getItemFolders = ({ itemId, itemType }) =>
  xhr({
    url: `${folderItemsEndpoint}/check_item?id=${itemId}&type=${itemType}`,
    method: 'GET',
  })

export default getItemFolders
